<template>
  <div
    class="border-1 border-gray-lighter rounded-md pt-12 px-5 pb-8 md:px-12 md:pb-9.6 max-w-2xl mx-auto bg-white"
    :class="{ 'md:sticky lg:top-52': sticky }"
  >
    <h3 class="abstract font-bold text-black-light text-center mb-11">
      <template v-if="userIsOwner">
        Sei il proprietario di questo immobile.
      </template>
      <template v-else>
        Ti interessa questo immobile?<br aria-hidden="true" />
        {{
          $store.state.auth.loggedIn
            ? 'Clicca il pulsante per essere ricontattato.'
            : 'Compila il form.'
        }}
      </template>
    </h3>
    <template v-if="userIsOwner">
      <UcrsButton
        type="primary"
        class="w-full"
        @click="$router.push(`/area-riservata/annunci/${property.id}`)"
      >
        Guardalo nell'area riservata
      </UcrsButton>
    </template>
    <template v-else>
      <OButton
        v-if="$store.state.auth.loggedIn"
        variant="primary"
        root-class="ucrs-button--large w-full"
        :disabled="isDisabled"
        @click.prevent="submit"
      >
        Voglio essere ricontattato
      </OButton>
      <form v-else>
        <ValidationObserver v-slot="{ errors }" ref="observer" :slim="true">
          <InputWithValidation
            :value="first_name"
            name="name"
            label="Nome*"
            placeholder="Nome*"
            rules="required|alpha_spaces"
            :errors="errors"
            :field-classes="errors.name?.length ? 'mb-22' : 'mb-6'"
            @input="onFormFieldEvent($event, 'first_name', 'name')"
            @focus="onTealiumFormFirstFieldFocus"
          />
          <InputWithValidation
            :value="last_name"
            name="surname"
            label="Cognome*"
            placeholder="Cognome*"
            rules="required|alpha_spaces"
            :errors="errors"
            :field-classes="errors.surname?.length ? 'mb-22' : 'mb-6'"
            @input="onFormFieldEvent($event, 'last_name', 'surname')"
          />
          <InputWithValidation
            :value="email"
            name="email"
            label="Email*"
            placeholder="Email*"
            rules="required|email"
            :errors="errors"
            :field-classes="errors.email?.length ? 'mb-22' : 'mb-6'"
            @input="onFormFieldEvent($event, 'email')"
          />
          <InputWithValidation
            :value="phone"
            name="phone"
            type="number"
            label="Telefono*"
            placeholder="Telefono*"
            rules="required|phone"
            :errors="errors"
            :field-classes="errors.phone?.length ? 'mb-22' : 'mb-6'"
            @input="onFormFieldEvent($event, 'phone')"
          />
          <InputWithValidation
            :value="message"
            name="message"
            label="Messaggio"
            placeholder="Messaggio"
            :field-classes="errors.message?.length ? 'mb-22' : 'mb-6'"
            @input="onFormFieldEvent($event, 'message')"
          />
          <p class="text-sm mb-6">* Campi obbligatori</p>
          <OField root-class="mb-6">
            <UcrsSwitch
              v-model="hasSellingInterest"
              name="hasSellingInterest"
              :true-value="1"
              :false-value="0"
              :left-label="true"
              >Sono interessato a vendere il mio immobile
            </UcrsSwitch>
          </OField>
          <OField root-class="mb-8">
            <UcrsSwitch
              v-model="signup"
              name="signup"
              :true-value="1"
              :false-value="0"
              :left-label="true"
              >Registrati all'area riservata e ricevi aggiornamenti su immobili
              simili
            </UcrsSwitch>
          </OField>
          <PrivacyCheckbox
            v-model="privacy"
            name="privacy"
            modal-width="123rem"
            :errors="errors"
            :class="errors.privacy?.length ? 'mb-22' : 'mb-6'"
          />
        </ValidationObserver>
        <OButton
          variant="primary"
          root-class="ucrs-button--large w-full"
          :disabled="isDisabled"
          @click.prevent="submit"
        >
          Invia richiesta
        </OButton>
      </form>
      <p class="mt-7 text-lg text-center">
        Numero verde
        <a
          class="text-blue font-bold underline outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:rounded focus-visible:ring-blue"
          href="tel:+39800896968"
        >
          800.89.69.68
        </a>
      </p>
    </template>
  </div>
</template>

<script>
// Mixins
import FormMixin from '~/mixins/form'
import PropertyMixin from '~/mixins/property'

import UcrsButton from '~/components/UcrsButton.vue'
import InputWithValidation from '~/components/InputWithValidation.vue'
import PrivacyCheckbox from '~/components/PrivacyCheckbox.vue'
import UcrsSwitch from '~/components/UcrsSwitch.vue'

export default {
  components: {
    UcrsButton,
    InputWithValidation,
    PrivacyCheckbox,
    UcrsSwitch,
  },

  mixins: [FormMixin, PropertyMixin],

  props: {
    property: {
      type: Object,
      default: () => {
        return null
      },
    },
    sticky: {
      type: Boolean,
      default: false,
    },
    inModal: {
      type: Boolean,
      default: false,
    },
    userIsOwner: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      message: '',
      privacy: false,
      hasSellingInterest: 0,
      signup: 0,
      isDisabled: false,
    }
  },
  created() {
    if (!this.$store.state.auth.loggedIn) return

    this.first_name = this.$store.state.auth.user.first_name
    this.last_name = this.$store.state.auth.user.last_name
    this.email = this.$store.state.auth.user.email
    this.phone = this.$store.state.auth.user.phone
    this.privacy = true

    this.$nuxt.$on('submit-loggedin', () => {
      this.submit()
    })
  },

  methods: {
    async validate() {
      await this.$refs.observer.validate()
      const fields = []
      if (this.$refs.observer.flags.invalid) {
        const errors = this.$refs.observer.errors
        for (const property in errors) {
          if (errors[property][0]) fields.push(property)
        }
      }
      return { isValid: this.$refs.observer.flags.valid, errorFields: fields }
    },
    async submit() {
      if (!this.$store.state.auth.loggedIn) {
        const validation = await this.validate()
        if (!validation.isValid) {
          const tealiumErrors = validation.errorFields.map((el) => {
            return { campo: el }
          })
          this.$tealium.track({
            event_name: 'errori_richiesta',
            errori_richiesta: tealiumErrors,
          })
          return
        }
      }

      this.isDisabled = true

      try {
        const propertyPrefix =
          this.property && this.property.building.category.name === 'Cantieri'
            ? `IDC`
            : `ID`

        const res = await this.$axios.post(`/_api/api/v3/leads`, {
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email,
          phone: this.phone,
          privacy: this.privacy ? 1 : 0,
          type: 'buy',
          is_quick_registration: this.signup,
          has_selling_interest: this.hasSellingInterest,
          property_id: this.property && `${propertyPrefix}-${this.property.id}`,
          ...(this.message ? { message: this.message } : {}),
        })

        const quickRegistration = res.data.data.quick_registration

        let content

        switch (true) {
          case !quickRegistration: // Manifestazione normale.
            content = `<p class="font-medium text-3xl mb-12 text-green">La manifestazione di interesse è stata inviata con successo.</p><p class="text-xl mb-8 text-green">Un nostro operatore ti contatterà nei prossimi giorni da questo numero di telefono +39 02 8681 4901 - al seguente recapito: <strong>${this.phone}</strong>. Se non riusciamo a trovarti libero, non preoccuparti. Ti invieremo un SMS con i nostri contatti e potrai richiamarci gratuitamente quando sarà più comodo per te.</p></p>`
            break

          case quickRegistration &&
            quickRegistration.message === 'user-created':
            content =
              '<p class="font-medium text-3xl mb-12 text-green">Registrazione avvenuta con successo!</p><p class="text-xl mb-8 text-green">Controlla la tua email per verificare il tuo account e impostare la tua password.<br aria-hidden="true" />Dopo la verifica potrai accedere all\'area riservata.</p>'
            break

          case quickRegistration &&
            quickRegistration.message === 'user-exists' &&
            quickRegistration.finalized:
            content = `<p class="font-medium text-3xl mb-12 text-green">La manifestazione di interesse è stata inviata con successo.</p><p class="text-xl mb-8 text-green">Un nostro operatore ti contatterà nei prossimi giorni da questo numero di telefono +39 02 8681 4901 - al seguente recapito: <strong>${this.phone}</strong>. Se non riusciamo a trovarti libero, non preoccuparti. Ti invieremo un SMS con i nostri contatti e potrai richiamarci gratuitamente quando sarà più comodo per te.</p></p><p class="text-xl text-green">Con questo indirizzo email risulti già registrato alla nostra Area Riservata. <a href="/area-riservata/login" class="underline hover:no-underline">Clicca qui per accedere al tuo account.</a></p>`
            break

          case quickRegistration &&
            quickRegistration.message === 'user-exists' &&
            !quickRegistration.finalized:
            content = `<p class="font-medium text-3xl mb-12 text-green">La manifestazione di interesse è stata inviata con successo.</p><p class="text-xl mb-8 text-green">Un nostro operatore ti contatterà nei prossimi giorni da questo numero di telefono +39 02 8681 4901 - al seguente recapito: <strong>${this.phone}</strong>. Se non riusciamo a trovarti libero, non preoccuparti. Ti invieremo un SMS con i nostri contatti e potrai richiamarci gratuitamente quando sarà più comodo per te.</p></p><p class="text-xl text-green">Il tuo account non è ancora finalizzato, controlla la tua email per confermare la registrazione.</p>`
            break

          case quickRegistration && quickRegistration.message === 'user-logged':
            content = `
              <p class="font-medium text-3xl mb-12 text-green">
                La manifestazione di interesse è stata inviata con successo.
              </p>
              <p class="text-xl mb-8 text-green">
                Un nostro operatore ti contatterà nei prossimi giorni da questo numero di telefono +39 02 8681 4901 - al seguente recapito: <strong>${this.phone}</strong>. Se non riusciamo a trovarti libero, non preoccuparti. Ti invieremo un SMS con i nostri contatti e potrai richiamarci gratuitamente quando sarà più comodo per te.
              </p>
              <p class="text-xl text-green">
                Attualmente risulti già loggato. <a href="/area-riservata/dashboard" class="underline hover:no-underline">Clicca qui visualizzare la tua dashboard.</a>
              </p>
            `
            break
        }

        this.leadTracking(
          res.data.data.lead_id,
          quickRegistration && quickRegistration.message === 'user-created',
          this.$store.state.auth.loggedIn
        )

        if (!this.$store.state.auth.loggedIn) {
          this.reset()
        }

        this.isDisabled = false

        // Quick registration V3: utente riceverà email con link per verifica
        // NON viene creata sessione automatica dal backend
        // L'utente dovrà cliccare il link nell'email per verificare e impostare password

        if (this.$store.state.auth.loggedIn && !this.property.is_favorite) {
          const res = await this.$axios.post('_api/api/v2/user/favorite', {
            id: this.property.id,
          })
          const { status, data } = res

          if (status !== 201) {
            throw new Error('Error during favorite saving.')
          }
          const { count } = data

          this.$emit('favorite-add')
          this.$authUtilities.updateUserCount('favorites', count)
        }

        if (!this.$store.state.auth.loggedIn) {
          const tealiumPayload = {
            event_name: 'aggiungi_preferiti',
            ...this.tealiumPayload,
          }

          const time = Date.now()
          this.$store.dispatch('interactions/setFavorite', {
            time,
            id: this.property.id,
            tealiumPayload,
          })
        }

        this.showResponseModal({
          icon: 'check',
          iconClasses: 'text-green',
          color: 'white',
          width: '83rem',
          text: content,
        })
      } catch (error) {
        this.showResponseModal({
          icon: 'danger',
          iconClasses: 'text-red-error',
          color: 'white',
          width: '83rem',
          text: `<p class="font-medium text-3xl">Errore nell'invio della manifestazione.</p>`,
        })

        this.isDisabled = false
      }
    },
    leadTracking(leadId, isQuickRegistration, userLoggedIn = false) {
      const tealiumPayload = {
        event_name: userLoggedIn ? 'ricontatto' : 'conferma_richiesta',
        id: this.property.id,
        ...(!userLoggedIn
          ? { annuncio_interesse_vendo: this.hasSellingInterest ? 'SI' : 'NO' }
          : {}),
        annuncio_categoria: this.$utilities.tealiumCategory(this.property),
        id_getrix: leadId,
        user_type: isQuickRegistration ? 'registrazione_light' : '',
        annuncio_vtour: this.property.features.virtual_tour ? '1' : '0',
        annuncio_vetrina: this.property.is_showcase ? '1' : '0',
        annuncio_certificato: this.property.certificate ? '1' : '0',
        annuncio_network:
          this.property.agent && this.property.agent.type === 'network_agenti'
            ? '1'
            : '0',
        ...(!userLoggedIn ? { user_email: this.email } : {}),
        ...(this.$config.uclamActive
          ? { annuncio_unicredit: this.property.source_id === 4 ? '1' : '0' }
          : {}),
      }

      this.$tealium.pageTrack(tealiumPayload, true)
    },
    showResponseModal(response) {
      this.$emit('submitted', response)
      if (this.inModal) this.$emit('close')
    },
    reset() {
      this.first_name = ''
      this.last_name = ''
      this.email = ''
      this.phone = ''
      this.message = ''
      this.privacy = false
      this.hasSellingInterest = 0
      this.signup = 0
      this.$refs.observer.reset()
    },
  },
}
</script>

<style lang="postcss">
@import '~/assets/css/components/field';
@import '~/assets/css/components/button';
@import '~/assets/css/components/input';
@import '~/assets/css/components/switch';
</style>
